import React from "react";

export default function ExecutiveBriefing({ executiveBriefing }) {
  return (
    <div style={briefingCardStyle}>
      <h2>📰 AI Daily Executive Briefing</h2>

      <p>
        <b>{executiveBriefing.greeting}</b> here is today&apos;s Ecovanta CRM
        intelligence summary.
      </p>

      <div style={briefingGridStyle}>
        <div>
          <strong>Active Leads</strong>
          <h3>{executiveBriefing.activeLeads}</h3>
        </div>

        <div>
          <strong>Expected Revenue</strong>
          <h3>€{executiveBriefing.expectedRevenue.toLocaleString()}</h3>
        </div>

        <div>
          <strong>Hot Leads</strong>
          <h3>{executiveBriefing.hotLeads}</h3>
        </div>

        <div>
          <strong>Likely Wins</strong>
          <h3>{executiveBriefing.likelyWins}</h3>
        </div>

        <div>
          <strong>At-Risk Deals</strong>
          <h3>{executiveBriefing.atRisk}</h3>
        </div>

        <div>
          <strong>Overdue Follow-Ups</strong>
          <h3>{executiveBriefing.overdue}</h3>
        </div>
      </div>

      <h3>AI Priorities</h3>

      {executiveBriefing.priorities.length > 0 ? (
        <ol>
          {executiveBriefing.priorities.map((priority, index) => (
            <li key={index}>{priority}</li>
          ))}
        </ol>
      ) : (
        <p>No urgent AI priorities today.</p>
      )}
    </div>
  );
}

const briefingCardStyle = {
  padding: "22px",
  borderRadius: "16px",
  background: "#f0fdfa",
  border: "1px solid #99f6e4",
  marginTop: 24,
  marginBottom: 28
};

const briefingGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
  gap: 16,
  marginTop: 18,
  marginBottom: 18
};
